module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "sert",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ii",
      "id": "pii",
      "role": "doc-pagebreak"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "height": "150",
      "src": "images/logo-class-200.jpg",
      "width": "159"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sered"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("EDITED")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("BY")]), _vm._v(" Kathryn Lofton "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("AND")]), _vm._v(" John Lardas Modern")]), _vm._v(" "), _c('p', {
    staticClass: "serah",
    staticStyle: {
      "font-style": "normal"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("BOOKS")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("IN")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("THE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("SERIES:")])]), _vm._v(" "), _c('p', {
    staticClass: "seraft"
  }, [_c('i', [_vm._v("The Lives of Objects: Material Culture, Experience, and the Real in the History of Early Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Maia Kotrosits")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Make Yourselves Gods: Mormons and the Unfinished Business of American Secularism")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Peter Coviello")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Hunted: Predation and Pentecostalism in Guatemala")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Kevin Lewis O’Neill")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("The Aliites: Race and Law in the Religions of Noble Drew Ali")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Spencer Dew")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Faking Liberties: Religious Freedom in American-Occupied Japan")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Jolyon Baraka Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Credulity: A Cultural History of US Mesmerism")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Emily Ogden")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Consuming Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by Kathryn Lofton")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('i', [_vm._v("Death Be Not Proud: The Art of Holy Attention")])]), _vm._v(" "), _c('p', {
    staticClass: "serau"
  }, [_vm._v("by David Marno")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ed22f6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-crosson-0003.vue
// module id = 60
// module chunks = 0